import fetch from 'utils/fetch';

export function doAssign(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/accountAssign',
        method: 'post',
        data
    });
}

export function upAssign(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/upAssign',
        method: 'put',
        data
    });
}
export function batchUpAssign(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/batchUpAssign',
        method: 'post',
        data
    });
}

export function accountAssignList(accountStart,accountEnd,agent,merchant,pageSize,currentPage) {
    const data = {
        accountStart,
        accountEnd,
        agent,
        merchant,
        pageSize,
        currentPage
    };
    return fetch({
        url: '/accountAssignList',
        method: 'get',
        params : data
    });
}

export function checkAssignValidity(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/checkAssignValidity',
        method: 'post',
        data
    });
}
export function batchDelAssign(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/batchDelAssign',
        method: 'post',
        data
    });
}




// WEBPACK FOOTER //
// ./src/api/accountAssign.js